import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cognos-validation-message',
  imports: [MessageModule],
  templateUrl: './validation-message.component.html',
  styleUrl: './validation-message.component.scss',
})
export class ValidationMessageComponent implements OnChanges, OnDestroy {
  @Input() control: AbstractControl<any, any> | null = null;
  @Input() customErrorMessages: { [key: string]: string } = {};

  defaultErrorMessages: { [key: string]: string } = {
    required: 'This field is required',
    email: 'Invalid email format',
    minlength: 'Minimum length not met',
    maxlength: 'Maximum length exceeded',
    pattern: 'Invalid format',
  };

  errorMessage: string | null = null;

  private _statusChangesSubscription: Subscription | null = null;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['control'] && this.control) {
      this.subscribeToChanges();
      this.updateErrorMessage();
    }
  }

  private subscribeToChanges(): void {
    // Cancel previous subscription.
    if (this._statusChangesSubscription) {
      this._statusChangesSubscription.unsubscribe();
    }

    this._statusChangesSubscription = this.control!.statusChanges.subscribe(
      () => {
        this.updateErrorMessage();
      }
    );
  }

  private updateErrorMessage(): void {
    if (!this.control || !this.control.errors || !this.control.dirty) {
      this.errorMessage = null;
      return;
    }

    const firstErrorKey = Object.keys(this.control.errors)[0];
    this.errorMessage =
      this.customErrorMessages[firstErrorKey] ||
      this.defaultErrorMessages[firstErrorKey] ||
      'Invalid field';
  }

  ngOnDestroy(): void {
    this._statusChangesSubscription?.unsubscribe();
  }
}
